import React, {Component} from "react";
import './Styles/LampaFeed.css';
import LaraItem from "./LaraItem";
import {LoadingImage} from "../App";
import ReactTwitchEmbedVideo from "react-twitch-embed-video"
import {supabase} from "../supabaseClient";


type myState = {downloaded:boolean, result:string[][]};
class LampaFeed extends Component<any, myState>{

	constructor() {
		super("");
		this.state = {
			downloaded:false,
			result:[]
		}
	}

	componentDidMount() {
		document.title = "LampaFeed";
		let link = document.querySelector("link[rel~='icon']");
		if(link != null) {
			link.setAttribute("href", "./lampa.ico");
		}

		let top = document.querySelector(".Logo-holder");
		console.log(top)
		if(top != null) {
			top.setAttribute("src", "./lampa.ico")
		}

		let topLink = document.querySelector("#topLink");
		console.log(topLink)
		if(topLink != null) {
			topLink.setAttribute("href", "https://www.twitch.tv/lampafeed")
		}

		this.downloadWishList();
	}

	downloadInvoked = false;

	downloadWishList() {

		if(this.state.downloaded)
			return

		supabase
			.from('lampa_feed')
			.select('image_url, title, subtitle, description, platform, status_class, record_link')
			.order('sort_order', {ascending: true})
			.then(({data, error}) => {
				if (error) {
					console.log(error);
					return;
				}
				const newResult: string[][] = (data || []).map((row: any) => ([
					row.image_url,
					row.title,
					row.subtitle,
					row.description,
					row.platform,
					row.status_class,
					row.record_link,
				]));

				this.setState({downloaded:true, result:newResult});
			})


	}

	gameElement(gameInfo: string[]){
		return <LaraItem {...gameInfo}/>
	}

	render() {
		let header = <header className="App-header">
			<p>LAMPAFEED</p>
			<p>Прохождение Tomb Raider от стримера LampaFeeD ^^</p>
		</header>;


		let games = LoadingImage();

		if (this.state.downloaded) {
			games = <div>{this.state.result.map((value) => this.gameElement(value))}</div>
		}

		console.log(games)

		return (<div>
			{header}
			<ReactTwitchEmbedVideo channel="lampafeed" chat="mobile"  height="600" width="620" /><br/>
			<div>{games}</div>

			<br/><br/><br/><br/><br/><br/>
		</div>);
	}


}


export default LampaFeed